import { createSelector } from 'reselect'
import { localize } from 'helpers/translator'

const pollSelector = state => state.poll

const editSettingsSelector = createSelector(
	[pollSelector],
	poll => {
		const settings = [
			{
				key: 'allowMultipleOptions',
				value: poll.settings.allowMultipleOptions,
				text: localize('poll_settings_message'),
				description: localize('poll_settings_description'),
			},
		]

		return { settings }
	}
)

export default editSettingsSelector
